import { removeSpace } from 'utils/masks';
import addressSchema from './addressSchema';

const addPaymentMethodSchema = {
  ...addressSchema,
  accountType: [{
    rule: 'required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }
      return true;
    },
  }],
  routingNumber: [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (!input) {
        return 'The input field is required';
      }

      if (`${input}`.replace('_', '').length < 9 || !formData?.isValidRoutingNumber) {
        return 'Routing Number is not valid';
      }

      return /^(\d)\1+$/.test(input) ? 'Routing Number is not valid' : true;
    },
  }],
  accountNumber: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return /^(\d)\1+$/.test(input) ? 'Account Number is not valid' : true;
    },
  }],
};

export default addPaymentMethodSchema;
